import { JwtPayload, jwtDecode } from 'jwt-decode';
import * as Yup from 'yup';

export interface TokenLoginValues {
	token: string;
}

const schema: Yup.ObjectSchema<TokenLoginValues> = Yup.object({
	token: Yup.string()
		.trim()
		.required('Enter a token')
		.test('valid-token', 'Invalid or expired token', (token) => {
			if (!token) return true;
			try {
				if (!/^[\w-]+\.[\w-]+\.[\w-]+$/.test(token)) return false;
				const payload = jwtDecode<JwtPayload>(token);
				return Boolean(
					payload &&
						(payload.exp === undefined ||
							(typeof payload.exp === 'number' && payload.exp * 1000 > Date.now())),
				);
			} catch {
				return false;
			}
		}),
});

export default schema;
